import { render, staticRenderFns } from "./siteSettings.vue?vue&type=template&id=0900e96d&"
import script from "./siteSettings.vue?vue&type=script&lang=js&"
export * from "./siteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports